import React from 'react';
import { IconProps } from '../../../../../types/components';

export default function ArrowRightLong({ iconClass, width }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 640 640"
      className={iconClass}
      width={width}
    >
      <path fill="currentColor" d="M601 337C610.4 327.6 610.4 312.4 601 303.1L465 167C455.6 157.6 440.4 157.6 431.1 167C421.8 176.4 421.7 191.6 431.1 200.9L526.1 295.9L56 295.9C42.7 295.9 32 306.6 32 319.9C32 333.2 42.7 343.9 56 343.9L526.1 343.9L431.1 438.9C421.7 448.3 421.7 463.5 431.1 472.8C440.5 482.1 455.7 482.2 465 472.8L601 337z" />
    </svg>
  );
}
